import { OddsButton } from '@/components/widgets/odds-button';
import { useGetBetTypeName, useGetGoal, useGetBetTypeSetting } from '@/hooks';
import { betTypeService } from '@/services/bettype.service';
import { Market, SportMatchModel } from '@nf/types/odds';
import { matchSpecialStyles } from '../match-special.style';
import { MaybeMatch } from '@nf/utils-common/fpw/monadic';
import { BetChoice } from '@/features/odds-page/types';
import { useOddsTableMarsContext } from '@/features/odds-table-mars/context';
import { cx } from 'class-variance-authority';
import { Dispatch, SetStateAction } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';


interface SpeacialBetTypesTabProps {
    BetTypeMarketsMap: Map<number | string, Market | undefined> | undefined;
    match: SportMatchModel;
    homeTeamName: string;
    awayTeamName: string;
}

export const SpeacialBetTypesOddsTable = ({
	BetTypeMarketsMap,
	match,
	homeTeamName,
	awayTeamName,
}: SpeacialBetTypesTabProps) => {
	const { sport, oddsType, actStatus } = useOddsTableMarsContext();
	const getGoal = useGetGoal();
	const getBetTypeSetting = useGetBetTypeSetting();
	const sortBetteams = ['1', '2', 'x'];
	return (
		BetTypeMarketsMap && [...BetTypeMarketsMap].map(([betTypeSrc, market]) => {
			const [betType] = betTypeService.convertSpecialBetType(betTypeSrc);
			const { betChoices: defaultBetChoice } = getBetTypeSetting(betType, sport);
			const betChoices: BetChoice[] = MaybeMatch([5, 15].includes(betType))
				.fold(
					() => defaultBetChoice,
					() => [...defaultBetChoice].sort((a, b) => sortBetteams.indexOf(a.betTeam) - sortBetteams.indexOf(b.betTeam))
				)

			return (
				market && betChoices.map(betChoice => {
					const displayClassName = betTypeService.getBetChoiceDisplaySettingBetTypeClassName(market.BetTypeId, betChoice.betTeam);
					return (
		
						<OddsButton
							key={`${market.MatchId}_${market.MarketId}_${market.BetTypeId}_${betChoice.betTeam}`}
							goal={getGoal(market, betChoice)}
							match={match}
							market={market}
							selection={market.Selections[betChoice.betTeam]}
							homeTeamName={homeTeamName}
							awayTeamName={awayTeamName}
							variant={displayClassName}
							betTeam={market.Selections[betChoice.betTeam].SelId}
							originalPrice={market.Selections[betChoice.betTeam].Price}
							sport={sport}
							type="OU"
							oddsType={oddsType}
							accountStatus={actStatus ?? 0}
						/>

		
					);
				})
			)
		})
	)
}

